import { useContext } from 'react'

import { SnackBarContext } from '@assembly/contexts/Snackbar/snackbar.context'

const useSnackbars = () => useContext(SnackBarContext)

export default useSnackbars
